import "./calculator.css";
import {Link} from "react-router-dom"
import React from "react";
import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png"
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import withdrawalBanner from "../images/withdrawal-banner.jpg";
import health from '../images/health.png';
import foreign from '../images/foreign.png';
import missing from '../images/missing.png';
import people from '../images/people.png';
import calendar from '../images/calendar.png';
import time from '../images/time.png';
import withdrawalStart from '../images/withdrawal-start.png';
import Slider from '@mui/material/Slider';
import Slider1 from '@mui/material/Slider';
import Slider2 from '@mui/material/Slider';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";




const Calculator = () => {

   window.scrollTo(0, 0)


  const [value, setValue] = useState(0);
  const [interest, setInterest] = useState(0);
  const [time, setTime] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

    const handleChangeInterest = (event, newValue1) => {
    setInterest(newValue1);
  };

      const handleChangeTime = (event, newValue2) => {
    setTime(newValue2);
  };


  return (
    <>

 <div className="plain-cont-calc padding-section-standard-top col-12 col-md-5 mx-auto">
        <div id="mobile-view" className="containeer-calc row d-flex justify-content-between text-center ">
          <div className="text-center pb-5">
            <h2 className="calc-h2 dark-text">
              How much do I need to contribute monthly to get my desired Pension?
            </h2>
        
          </div>
           <div id="mobile-view" className="d-flex justify-content-between" >
   
                <div className="card calc-crd mx-auto">
                  <div className="text-start">

                    <form>
                        <div class="mb-3">
                          <label for="exampleInputEmail1" className="form-label dark-p-calc-2">How much do you want to receive monthly after retirement? (₦)</label>
                          <input type="email" className="form-control calc-input" id="exampleInputEmail1" aria-describedby="emailHelp" />
                         
                            </div>
                             <div class="mb-3">
                          <label for="exampleInputEmail1" className="form-label dark-p-calc-2"> How many years until you retire? <span class="badge d-none d-md-block text-bg-success sizePlacement value-style-ytr"> {value} year(s) </span> </label>
                         <span class="badge d-block d-md-none text-bg-success sizePlacement value-style"> {value} year(s) </span>
                         <Slider
      value={value}
      onChange={handleChange}
      valueLabelDisplay="auto"
      min={1}
      max={50}
      style={{ 
        width: '100%',
        color: '#e4e4e4' ,
     }}
    />
                            </div>
                                 <div class="mb-3">
                          <label for="exampleInputEmail1" className="form-label dark-p-calc-2">What annual interest rate do you expect? <span class="badge d-none d-md-block text-bg-success sizePlacement value-style-interest"> {interest}% </span></label>
                                                  <span class="badge d-block d-md-none text-bg-success sizePlacement value-style"> {interest}% </span>
                                                   <Slider1
      value={interest}
      onChange={handleChangeInterest}
      valueLabelDisplay="auto"
      min={1}
      max={20}
      style={{ width: '100%',
         color: '#e4e4e4' ,
       }}
    />
                            </div>
                             <div class="mb-5">
                          <label for="exampleInputEmail1" className="form-label dark-p-calc-2"> How many years do you expect to receive pension? <span class="badge d-none d-md-block text-bg-success sizePlacement value-style-benefits"> {time}year(s) </span> </label>
                                                    <span class="badge d-block d-md-none text-bg-success sizePlacement value-style"> {time} year(s) </span>
                                                   <Slider2
      value={time}
      onChange={handleChangeTime}
      valueLabelDisplay="auto"
      min={1}
      max={50}
      style={{ width: '100%',
         color: '#e4e4e4' ,
       }}
    />
                            </div>

                        

                              <hr className="btm-bdr-rma" />

                              <div className="row mt-5 "> 
                                <div className="col-12 col-md-7 padding-off"> 
                                 <p className="dark-p-calc">
                                    Total RSA Balance Needed at Retirement
                                     </p>
                                </div>
                                   <div className="col-12 col-md-5 text-end"> 
                                    <p className="result-style balance-style">
                                   ₦32,000,000.00
                                     </p>
                                </div>
                              </div>

                                  <div className="row mt-4"> 
                                <div className="col-12 col-md-7 padding-off"> 
                                 <p className="dark-p-calc">
                                   Monthly Contribution Required to Meet Your Goal
                                     </p>
                                </div>
                                   <div className="col-12 col-md-5 text-end goal-style"> 
                                    <p className="result-style">
                                  ₦280,000.00
                                     </p>
                                </div>
                              </div>


                       
</form>
                    
                


                  </div>
                </div>
            

           


             


         
      </div>   
</div>

    <p className="card-text pt-3 grey-p-calc disclaimer-padding" >
                        
                    <span className="dark-p-calc"> Disclaimer: </span>   The calc on this page is indicating and strictly for information purposes. 
                      Leadway Pensure PFA's obligations with respect to its services on this page are governed solely by the agreements 
                      under which they are provided and nothing hereof should be construed to alter such agreements.        
                      
                       </p>
      </div>



 
    </>
  );
};

export default Calculator;